<template>
  <div id="app">
    <router-view  v-if="isRouterAlive"> </router-view>
  </div>
</template>

<script>
import authservice from "./auth/authService.js"

export default {
  name: 'App',
  provide () {
    return {
      reload: this.reload
    }
  },
  data(){
    return{
      isRouterAlive: true
    }
  },
   methods: {
    reload () {
      this.isRouterAlive = false
      this.$nextTick(function () {
        this.isRouterAlive = true
      })
    }
  },

  created: function () {
    authservice.authLogin().then(res => {
    //  this.$router.replace("/Home")
    //   console.log('-------------ddddd')
    })
  }


}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/App.vue